import React, { useState } from "react";
import { useParams, Redirect } from "react-router-dom";
import { useFirestoreConnect, isLoaded, isEmpty, useFirestore, useFirebase } from 'react-redux-firebase'
import { useSelector } from "react-redux";

import Page from './Page';
import LinkButton from '../components/LinkButton';
import PodcastForm from '../components/PodcastForm';
import { useSubmissionSelector } from '../hooks';

const PodcastEdit = () => {
  const { podcastId } = useParams();
  const [ isSuccess, setIsSuccess ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(false);
  const firestore = useFirestore();
  const firebase = useFirebase();
  const podcast = useSubmissionSelector(podcastId);
  const users = useSelector(state => state.firestore?.data?.users)
  const userId = podcast?.userId;

  useFirestoreConnect([
    {
      collection: 'submissions',
      doc: podcastId
    },
  ]);

  useFirestoreConnect([
    {
      collection: 'users',
    }
  ])

  const onSave = async (formData) => {
    setIsLoading(true);

    const submission = { ...formData }
    const file = submission.contentFile && submission.contentFile.length === 1 && submission.contentFile[0];
    delete submission.contentFile;

    if (file) {
      const fileRef = firebase.storage().ref().child('submissions').child(podcastId);
      const fileSnapshot = await fileRef.put(file);
      submission.contentFileUrl = await fileSnapshot.ref.getDownloadURL();
    }

    firestore.collection('submissions').doc(podcastId).set({
      ...submission,
      narrations: submission.narrations || []
    }, {merge: true});

    setIsLoading(false);
    setIsSuccess(true);
  }

  const podcastUrl = `/podcasts/details/${podcastId}`
  const action = <LinkButton to={podcastUrl}>View podcast</LinkButton>
  const userName = users && userId in users && (users[userId].companyName || users[userId].name);
  const breadcrumbs = [
    {title: "Podcasts", link: "/podcasts"},
    {title: userName, link: `/podcasts/by-user/${userId}`},
    {title: podcast?.title, link: ''}
  ]

  if (!isLoaded(podcast) || isLoading) {
    return <></>
  }

  if (isLoaded(podcast) && isEmpty(podcast)) {
    return <Redirect to="/" />
  }

  if (isSuccess) {
    return <Redirect to={podcastUrl} />
  }

  return (
    <Page action={action} breadcrumbs={breadcrumbs}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <PodcastForm podcast={podcast} onSave={onSave} />
          </div>
        </div>
      </div>
    </Page>
  )
}

export default PodcastEdit;
